// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from 'controllers/application';

import HelloController from 'controllers/hello_controller';
import ModalFormController from 'controllers/modal_form_controller';
import PersistentLabEdit from 'controllers/persistent_lab_edit_controller';
import ResourceUpdates from 'controllers/resource_updates_controller';
import ConsoleStory from 'controllers/console_story_controller';
import UnauthorizedController from 'controllers/unauthorized_controller';
import Resources from 'controllers/resources_controller';
import EventUsers from 'controllers/event_users_controller';
import ReassignModal from 'controllers/reassign_modal_controller';
import CatalogController from 'controllers/catalog_controller';
import InstanceAlertController from 'controllers/instance_alert_controller';
import FavoriteController from 'controllers/favorite_controller';
import SubmitButtonController from 'controllers/submit_button_controller';
import PdfHistoryController from 'controllers/pdf_history_controller';
import CriticalLaunchController from 'controllers/critical_launch_controller';
import ReportScheduleLogsController from 'controllers/report_schedule_logs_controller';
application.register( 'hello', HelloController );
application.register( 'modal-form', ModalFormController );
application.register( 'persistent-lab', PersistentLabEdit );
application.register( 'resource-updates', ResourceUpdates );
application.register( 'console_story', ConsoleStory );
application.register( 'unauthorized', UnauthorizedController );
application.register( 'resources', Resources );
application.register( 'event-users', EventUsers );
application.register( 'reassign-modal', ReassignModal );
application.register( 'catalog', CatalogController );
application.register( 'instance-alert', InstanceAlertController );
application.register( 'favorite', FavoriteController );
application.register( 'submit-button', SubmitButtonController );
application.register( 'pdf-history', PdfHistoryController );
application.register( 'critical-launch', CriticalLaunchController );
application.register( 'report-schedule-logs', ReportScheduleLogsController );
